import styled from "styled-components";
import { devices } from "../../../../globalStyle";
import check from '../../../../assets/addStockModal/pages/check.svg'
import cross from '../../../../assets/addStockModal/pages/cross.svg'


export const Container = styled.div`
  width: 84.7vw;
  max-height: 56.5vh;
  margin-top: 2.2vh;
  margin-left: 1vw;
  padding-right: 0.1vw;
  padding-bottom: 0.1vh;
  background-color: #f5f5f5;
  overflow-x: auto;
  font-family: 'Inter', sans-serif;
  
  @media ${devices.smallDesktop} {
    width: calc(100vw - 40px);
    max-height: calc(100vh - 200px);
    margin-left: 20px;
    margin-right: 20px;
  }
  
  @media ${devices.largeDesktop} {
    width: 87.7vw;
  }
  .short {
    width: 83.7vw;
    @media ${devices.smallDesktop} {
      width: calc(100vw - 60px);
    }
    @media ${devices.largeDesktop} {
      width: 87.6vw;
    }
  }

  /* Estilos do scrollbar */
  ::-webkit-scrollbar {
    width: 8px; /* Largura do scrollbar */
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0; /* Cor do fundo do track */
    border-radius: 10px; /* Bordas arredondadas do track */
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff; /* Cor do thumb (parte que você pode arrastar) */
    border-radius: 10px; /* Bordas arredondadas do thumb */
    border: 2px solid #c0c0c0; /* Adiciona uma borda para que o thumb pareça mais fino */
  }
`

export const Table = styled.table`
  text-align: start;
  border-collapse: collapse;
  width: 100%;
  padding-right: 4vw;

  tr:nth-child(2) td:first-child {
    border-top-left-radius: 0.7vw;
  }

  tr:nth-child(2) td:last-child {
    border-top-right-radius: 0.7vw;
  }

  tr:last-child td:first-child {
    border-bottom-left-radius: 0.7vw;
  }

  tr:last-child td:last-child {
    border-bottom-right-radius: 0.7vw;
  }
`

export const HeaderRow = styled.tr`
  position: sticky;
  top: 0;
  height: 5vh;
  background-color:#f5f5f5;
  z-index:1;
`

export const HeaderCell = styled.th`
  color: #696969;
  text-align: start;
  border: 0;
  font-size: 14px;
  padding-left: 1vw;
  
  @media ${devices.smallDesktop} {
    font-size: 12px;
    padding-left: 12px;
  }
`

export const ProfileRow = styled.tr`
  height: 10vh;
  background-color:#fff;
`

export const ProfilesCell = styled.td`
  width: 15vw;
  text-align: start;
  font-size: 14px;
  padding-left: 1vw;
  border-bottom: solid 1px #ebebeb;
  word-wrap: break-word;
  overflow-wrap: break-word;
  
  @media ${devices.smallDesktop} {
    width: auto;
    min-width: 120px;
    padding-left: 12px;
    font-size: 12px;
  }
  
  img{
    cursor:pointer;
  }
`

export const ContentCell = styled.div`
  display:flex;
  gap:1vw;
  
  .disabled{
    filter:grayscale(1);
    cursor:default;
  }
`

export const Input = styled.input`
  width: 11.5vw;
  height: 4.3vh;
  background-color: #EBEBEB;
  border: 0;
  border-radius: 2vw;
  margin-top: 0.8vh;
  padding-left: 1vw;
  padding-right: 1vw;
  color:#696969;
  font-weight:500;
  :focus {
      outline: 0;
  }
`

export const SwitchesDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const SwitchDiv = styled.div`
    display: flex;
    flex-direction: column;
`

export const SwitchBox = styled.label`
    display: inline-block;
    position: relative;
    width: 60px;
    height: 34px;
`

export const SwitchInput = styled.input`
    opacity: 0;
    width: 0;
    height: 0;

    :checked + .slider {
        background-color: #2196F3;
        border: 0;
        padding: 2px;
    }

    :focus + .slider {
        box-shadow: 0 0 1px #2196F3;
    }

    :checked + .slider:before {
        background-image: url(${check});
        background-repeat: no-repeat;
        background-position: center;
        background-size: 15px 15px;
        background-color: #fff;
        -webkit-transform: translateX(24px);
        -ms-transform: translateX(24px);
        transform: translateX(24px);
    }
`

export const SwitchSlider = styled.span`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 34px;
    border: #696969 2px solid;

    :before {
        display: block;
        position: relative;
        content: "";
        height: 24px;
        width: 24px;
        left: 5.5px;
        top: 2.8px;
        background-color: #696969;
        border-radius: 50%;
        transition: all 0.4s;
        background-image: url(${cross});
        background-repeat: no-repeat;
        background-position: center;
        background-size: 11px 11px;
    }
`